import { render, staticRenderFns } from "./HorizontalRule.vue?vue&type=template&id=13cdb08d&"
import script from "./HorizontalRule.vue?vue&type=script&lang=ts&"
export * from "./HorizontalRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports